// Keep imported browser history and saved conversations within the API limits.
export const serializeSavedChat = (chat) => {
  if (!chat?.id || !/^[\w-]{1,80}$/.test(chat.id)) return null;
  const messages = (chat.messages || [])
    .filter((message) => !message.isError && ['user', 'assistant'].includes(message.role) && message.content?.trim())
    .slice(-100)
    .map(({ role, content }) => ({ role, content: content.slice(0, 8000) }));
  while (messages.reduce((length, message) => length + message.content.length, 0) > 32000) messages.shift();
  if (!messages.some((message) => message.role === 'user')) return null;
  return {
    id: chat.id,
    title: String(chat.title || messages.find((message) => message.role === 'user').content).slice(0, 120),
    messages,
    updatedAt: Math.min(Number(chat.updatedAt) || Date.now(), Date.now()),
  };
};
